import { sha256 } from '@rhg/utils/string';

export async function getLocalStorageUserSha(
    localStorageId: string,
    userId: string | undefined
) {
    if (userId) {
        const localStorageKey = `${localStorageId}-${await sha256(userId)}`;
        return localStorageKey;
    }
    return localStorageId;
}
